import { render, staticRenderFns } from "./DropdownCloseButton.vue?vue&type=template&id=20aa7552&"
import script from "./DropdownCloseButton.vue?vue&type=script&lang=js&"
export * from "./DropdownCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCloseButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports